{
  "organization.status.active": "Active",
  "organization.status.disabled": "Disabled",
  "organization.status.pending": "Pending activation",
  "eventTypes.title": "Event types",
  "eventTypes.intro": "Configure your own event types. Confirm defaults when creating an individual event.",
  "eventTypes.empty": "There are no event types yet. Create one before adding your first event.",
  "eventTypes.error": "Settings could not be saved or loaded. Check the result before trying again.",
  "eventTypes.saved": "Event type saved.",
  "eventTypes.new": "New type",
  "eventTypes.settings": "Event type settings",
  "eventTypes.code": "Unique code (no spaces)",
  "eventTypes.cs": "Czech name",
  "eventTypes.en": "English name",
  "eventTypes.mode": "Enrollment mode",
  "eventTypes.mode.self_service": "Participants enroll themselves",
  "eventTypes.mode.admin_only": "Administrators enroll participants",
  "eventTypes.mode.mixed": "Participants and administrators",
  "eventTypes.capacity": "Default capacity (empty = unlimited)",
  "eventTypes.enrollment": "Supports participant enrollment",
  "eventTypes.waitlist": "Enable waitlist by default",
  "eventTypes.status": "Type availability",
  "eventTypes.status.active": "Active",
  "eventTypes.status.archived": "Archived",
  "organization.title": "Your organizations",
  "organization.intro": "Choose where you want to work. Access is managed by the organization administrator.",
  "organization.empty": "You do not belong to an organization yet.",
  "organization.create": "Create an organization",
  "organization.name": "Organization name",
  "organization.ownerNote": "You will own and administer this organization, not the platform.",
  "organization.closed": "Organization creation is limited to approved accounts in this closed pilot.",
  "organization.error": "The action could not be completed. Reload your account or contact an administrator. Check the outcome before creating another organization.",
  "organization.members": "Organization members",
  "organization.subject": "Keycloak user ID",
  "organization.subjectHelp": "Use the exact ID of the manually created account, not its email. Access becomes available when that account signs in.",
  "organization.roles": "Role-based permissions",
  "organization.active": "Access enabled",
  "organization.owner": "Owner",
  "organization.ownerProtected": "Owner access and your own access cannot be changed here. Ownership transfer is outside the pilot.",
  "organization.saved": "Membership saved.",
  "organization.readOnly": "You have read-only access.",
  "app.name": "Event",
  "app.tagline": "Event management platform",
  "common.loading": "Loading…",
  "common.error": "Something went wrong.",
  "common.retry": "Retry",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.save": "Save",
  "common.back": "Back",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.create": "Create",
  "common.empty": "No records.",
  "common.yes": "Yes",
  "common.no": "No",
  "common.notSignedIn": "Sign in to perform this action.",
  "common.signInHint": "Continue through sign-in.",
  "auth.signIn": "Sign in",
  "auth.signOut": "Sign out",
  "auth.greeting": "Welcome, {name}.",
  "auth.unauthorized": "Authentication is required for this action.",
  "auth.forbidden": "You do not have permission to perform this action.",
  "auth.loadingTitle": "Checking access",
  "locale.cs": "Czech",
  "locale.en": "English",
  "tenant.default": "eDO",
  "tenant.label": "Organization",
  "tenant.current": "Current organization",
  "session.label": "Signed in as",
  "session.none": "Not signed in",
  "session.devHint": "Demo access is intended only for validating roles outside production sign-in.",
  "session.signOut": "Sign out",
  "role.attendee": "Attendee",
  "role.attendee.description": "Enrolls in events and completes tasks.",
  "role.manager": "Manager",
  "role.manager.description": "Tracks team attendance and reports.",
  "role.organizer": "Organizer",
  "role.organizer.description": "Runs an event and manages attendance on the day.",
  "role.event_admin": "Event admin",
  "role.event_admin.description": "Manages the event catalog and publication.",
  "role.hr": "HR",
  "role.hr.description": "Cross-org access to attendance and reporting.",
  "role.reviewer": "Reviewer",
  "role.reviewer.description": "Reviews and grades attendee submissions.",
  "role.sys_admin": "System admin",
  "role.sys_admin.description": "Organization administration of identity, settings, and operational areas.",
  "role.auditor": "Auditor",
  "role.privacy_officer": "Authorized data processing officer",
  "role.privacy_officer.description": "Prepares and approves organization data processing rules; this does not automatically appoint a DPO.",
  "role.auditor.description": "Read-only audit access across the organization.",
  "role.platform_admin": "Platform admin",
  "role.platform_admin.description": "Administration of organizations and platform operations.",
  "nav.attendee": "Attendee",
  "nav.admin": "Admin",
  "nav.platform": "Platform",
  "nav.workspaces": "Workspaces",
  "nav.continue": "Continue to the app",
  "nav.overview": "Overview",
  "nav.tenants": "Organizations",
  "nav.openWorkspace": "Open",
  "nav.localeSwitch": "Language",
  "nav.events": "Events",
  "nav.identity": "Identity",
  "nav.enrollments": "My enrollments",
  "nav.scanner": "Scanner",
  "landing.eyebrow": "Event application",
  "landing.headline": "{app}: enrollments, attendance, and tasks made clear",
  "landing.subheadline": "One place for attendees, organizers, and platform administrators. After sign-in, the app opens the right workspace for your role.",
  "landing.cta.secondary": "View sign-in options",
  "landing.sectionsLabel": "Workspace overview",
  "landing.section.attendee.title": "For employees and attendees",
  "landing.section.attendee.body": "Attendees see available events, their enrollments, entry QR code, and tasks to complete.",
  "landing.section.admin.title": "For organizers and event administrators",
  "landing.section.admin.body": "Manage schedules, capacity, attendance, reviews, and reporting in one place.",
  "landing.section.platform.title": "For platform administration",
  "landing.section.platform.body": "A separate workspace for organizations, status, and core operational rules.",
  "landing.note.title": "How access works",
  "landing.note.body": "After sign-in, the app shows only the areas that match the user's role and organization.",
  "landing.note.identity": "Attendee, organizer, administrator, and platform administrator workspaces stay separated. Signing in does not by itself grant access to an organization's events.",
  "landing.story.kicker": "Clear event flow",
  "landing.story.title": "Calm control across event delivery",
  "landing.story.body": "From registration to attendance and evaluation, every user has a clear next step.",
  "landing.story.metricAttendance": "Attendance confidence",
  "landing.story.metricHandoff": "Tracked handoffs",
  "landing.backHome": "Back to home",
  "home.headline": "Welcome to the {app} platform",
  "home.subheadline": "This is the bootstrap version of the client shell. Module-specific content lands in later waves.",
  "home.cta.attendee": "Enter as attendee",
  "home.cta.admin": "Open admin area",
  "signin.title": "Sign in",
  "signin.compact.intro": "Sign in and continue to your workspace.",
  "signin.compact.organizationTitle": "Welcome back",
  "signin.compact.organizationIntro": "Sign in with your account and continue to {organization}.",
  "signin.compact.organizationBack": "Back to the organization page",
  "signin.intro": "Sign in with your account for this service. The app opens the workspace available to your permissions.",
  "signin.help.title": "Not sure where you will land?",
  "signin.help.label": "Sign-in help",
  "signin.help.body": "The target workspace is not selected manually. The app chooses it from the access you have for your organization.",
  "signin.fact.account.label": "Account",
  "signin.fact.account.value": "Secure sign-in",
  "signin.fact.workspace.label": "Workspace",
  "signin.fact.workspace.value": "Role based",
  "signin.fact.language.label": "Language",
  "signin.fact.language.value": "Czech and English",
  "signin.back": "Back to sign-in options",
  "signin.environment": "Environment",
  "signin.appEnv.local": "Local",
  "signin.appEnv.pilot": "Pilot",
  "signin.appEnv.production": "Production",
  "signin.posture.label": "Posture",
  "signin.posture.local_development.title": "Local validation",
  "signin.posture.local_development.body": "This environment is for internal validation and must not be confused with production access.",
  "signin.posture.pilot_rehearsal.title": "Pilot validation",
  "signin.posture.pilot_rehearsal.body": "This environment is intended for pilot and demo use. Final production sign-in rules remain a separate decision.",
  "signin.posture.production_external_identity.title": "External account management",
  "signin.posture.production_external_identity.body": "Sign-in uses external account management without demo access.",
  "signin.mode.mock_oidc": "Demo access",
  "signin.mode.external_oidc": "Secure sign-in",
  "signin.sso.badge": "Recommended entry",
  "signin.sso.title": "Secure sign-in",
  "signin.sso.body": "Continue through this service's account management. Access to events depends on your organization membership and assigned permissions.",
  "signin.sso.posture.local_development": "Internal validation can use a safely separated demo path.",
  "signin.sso.posture.pilot_rehearsal": "The pilot uses the approved sign-in path for this environment.",
  "signin.sso.posture.production_external_identity": "Sign-in uses the configured identity provider.",
  "signin.sso.cta": "Continue to sign-in",
  "signin.sso.notConfigured": "Sign-in is not completed in this environment yet. Contact the application administrator.",
  "signin.sso.localMode": "This environment uses demo sign-in to validate roles and journeys.",
  "signin.readiness.label": "Readiness",
  "signin.readiness.productionSafe": "Production configuration without demo access",
  "signin.readiness.nonProduction": "Pilot mode",
  "signin.readiness.browserConfigured": "Sign-in configured",
  "signin.readiness.browserMissing": "Sign-in incomplete",
  "signin.dev.badge": "Pilot demo",
  "signin.dev.badgeDisabled": "Disabled in this environment",
  "signin.dev.title": "Demo access",
  "signin.dev.body": "Use a prepared demo account to validate individual roles and workspaces.",
  "signin.dev.posture.local_development": "Demo accounts help validate journeys without production sign-in.",
  "signin.dev.posture.pilot_rehearsal": "Keep demo access limited to controlled pilot walkthroughs.",
  "signin.dev.posture.production_external_identity": "Demo access should be disabled in production.",
  "signin.dev.cta": "Choose demo account",
  "signin.dev.unavailable": "Demo access is not enabled in this environment.",
  "signin.dev.detail": "Choose a prepared demo account. After sign-in, the app sets the matching organization and roles automatically.",
  "signin.dev.empty": "No demo accounts are available.",
  "signin.dev.subjectLabel": "Demo account",
  "signin.dev.locale": "Preferred language: {locale}",
  "signin.dev.submit": "Sign in with this account",
  "signin.callback.title": "Completing sign-in",
  "signin.callback.failedTitle": "Sign-in was not completed",
  "signin.callback.body": "Processing the return from external sign-in and establishing the web app session.",
  "signin.oidc.failed": "Sign-in could not be completed. Try signing in again. If the problem continues, contact the administrator.",
  "signin.oidc.expired": "Your session has expired or cannot be refreshed safely. Please sign in again.",
  "signin.story.kicker": "After sign-in",
  "signin.story.title": "Identity resolves into the right workspace",
  "signin.story.body": "Attendees, organizers, and platform administrators see separated and understandable parts of the app.",
  "signin.story.metricRoles": "Role-aware routing",
  "signin.story.metricTenant": "Organization from session",
  "signin.story.metricAttendeeValue": "My events",
  "signin.story.metricAttendee": "Enrollments, QR code, and tasks.",
  "signin.story.metricAdminValue": "Manage",
  "signin.story.metricAdmin": "Events, attendance, reviews, and reports.",
  "signin.story.metricPlatformValue": "Platform",
  "signin.story.metricPlatform": "Separated organization administration.",
  "signin.story.rowAccount": "Sign-in confirms the user and opens available roles.",
  "signin.story.rowWorkspace": "Roles and organization decide the post-login landing path.",
  "signin.story.rowLanguage": "The interface is ready in Czech and English.",
  "attendee.title": "Attendee area",
  "attendee.intro": "Events, enrollments and attendance will show up here.",
  "attendee.context": "Signed in as {user} for organization {tenant}.",
  "attendee.story.kicker": "Guided workspace",
  "attendee.story.title": "Your next actions stay visible",
  "attendee.story.body": "Upcoming events, enrollment status, and assigned work remain in one calm, guided view.",
  "attendee.story.rowEvent": "Next published event",
  "attendee.story.rowEventMeta": "Registration window, location, and access stay easy to scan.",
  "attendee.story.rowTask": "Outstanding participant work",
  "attendee.story.rowTaskMeta": "Uploads, returns, and reviews stay visible without extra navigation.",
  "attendee.events.title": "Upcoming events",
  "attendee.events.empty": "No events are currently published.",
  "attendee.events.emptyBody": "When an organizer publishes a new event, it will appear here with date, location, and enrollment options.",
  "attendee.events.detailCta": "Event detail",
  "attendee.home.eventsBody": "Browse published events, inspect registration windows, and prepare before you enroll.",
  "attendee.home.enrollmentsBody": "Track your current registrations, waitlist status, and event entry codes in one place.",
  "attendee.home.tasksBody": "Return to assigned work, uploads, and submissions that still need your action.",
  "attendee.enrollments.title": "My enrollments",
  "attendee.enrollments.empty": "You have not enrolled in any events yet.",
  "attendee.enrollments.emptyBody": "Choose an event from the event list. After enrolling, you will see registration status and an entry QR code here.",
  "attendee.enrollments.status.registered": "Registered",
  "attendee.enrollments.status.waitlisted": "Waitlist (#{position})",
  "attendee.enrollments.status.cancelled": "Cancelled",
  "attendee.enrollments.cancel": "Cancel enrollment",
  "attendee.enrollments.cancelConfirm": "Do you really want to cancel this enrollment?",
  "attendee.enrollments.showQr": "Show QR code",
  "attendee.enrollments.tokenHeadline": "Your entry code",
  "attendee.enrollments.tokenHint": "Present this code to the organiser at the event.",
  "attendee.enrollments.tokenExpiresAt": "Valid until {date}",
  "attendee.enrollments.tokenExpiresLabel": "Valid until",
  "attendee.enrollments.tokenJtiLabel": "Code ID",
  "attendee.enrollments.tokenJti": "Code ID: {jti}",
  "attendee.enrollments.qrLabel": "Scannable QR code for event entry",
  "attendee.enrollments.tokenFallback": "If scanning is unavailable, the organiser can use the technical token below.",
  "attendee.enrollments.tokenDetails": "Show technical token",
  "attendee.enrollments.summary.waitlisted": "Waitlist",
  "attendee.enroll.cta": "Enroll",
  "attendee.enroll.full": "Capacity reached",
  "attendee.enroll.waitlist": "Join waitlist",
  "attendee.enroll.closed": "Registration is not open.",
  "attendee.enroll.success.registered": "You are enrolled.",
  "attendee.enroll.success.waitlisted": "You are on the waitlist.",
  "event.state.draft": "Draft",
  "event.state.published": "Published",
  "event.state.registration_open": "Registration open",
  "event.state.in_progress": "In progress",
  "event.state.completed": "Completed",
  "event.state.archived": "Archived",
  "event.capacity.label": "Capacity",
  "event.capacity.unlimited": "Unlimited",
  "event.capacity.remaining": "Seats left: {remaining} / {capacity}",
  "event.capacity.full": "Full",
  "event.startsAt": "Starts at",
  "event.endsAt": "Ends at",
  "event.registrationWindow": "Registration window",
  "event.location": "Location",
  "event.type": "Event type",
  "admin.title": "Event administration",
  "admin.intro": "The workspace shows only areas that match your roles and permissions.",
  "admin.story.kicker": "Operational command",
  "admin.story.title": "Operational readiness at a glance",
  "admin.story.body": "Event lifecycle, on-site scanning, reviews, and reporting stay aligned in one controlled workspace.",
  "admin.story.metricScanner": "Day-of-event pulse",
  "admin.story.rowLifecycle": "Event lifecycle control",
  "admin.story.rowLifecycleMeta": "Publication, registration, and completion remain traceable.",
  "admin.story.rowScanner": "Attendance operations",
  "admin.story.rowScannerMeta": "On-site capture stays resilient even during network interruptions.",
  "admin.story.rowReporting": "Reporting and exports",
  "admin.story.rowReportingMeta": "Completion and handoff signals remain explicit for stakeholders.",
  "admin.workspace.events": "Event catalogue and detail management, including lifecycle transitions and capacity handling.",
  "admin.workspace.scanner": "Organizer day-of-event operations, including offline queueing and check-in flow.",
  "admin.workspace.reviews": "Reviewer queue and decisions over attendee submissions.",
  "admin.workspace.reporting": "Reports, exports, and follow-up views available to your permissions.",
  "admin.workspace.identity": "Roles, group mappings, and effective access overview for the organization.",
  "admin.events.title": "Event catalog",
  "admin.events.newCta": "New event",
  "admin.events.empty": "No events have been created yet.",
  "admin.events.emptyBody": "Start by creating a scheduled event. Attendees will see it only after it is published and registration is opened.",
  "admin.events.transitionTo": "Transition to",
  "admin.events.create.title": "New event",
  "admin.events.create.cta": "Create event",
  "admin.events.form.eventType": "Event type",
  "admin.events.form.code": "Code",
  "admin.events.form.section.basics": "Core event setup",
  "admin.events.form.section.copy": "Participant-facing copy",
  "admin.events.form.section.schedule": "Schedule and registration",
  "admin.events.form.section.capacity": "Capacity and waitlist",
  "admin.events.form.section.location": "Location and timezone",
  "admin.events.form.help.basics.label": "Core setup help",
  "admin.events.form.help.basics.body": "The event type defines default rules and copy. Keep the code short and easy for organizers to recognize.",
  "admin.events.form.help.copy.label": "Participant copy help",
  "admin.events.form.help.copy.body": "The Czech title is required. Fill in English title and summary when the event should be clear in the English interface as well.",
  "admin.events.form.help.schedule.label": "Schedule help",
  "admin.events.form.help.schedule.body": "The event date and registration window can be different. Attendees see enrollment options according to the current event state.",
  "admin.events.form.help.capacity.label": "Capacity help",
  "admin.events.form.help.capacity.body": "Capacity limits confirmed attendees. The waitlist records additional interest without overbooking the event.",
  "admin.events.form.titleCs": "Title (Czech)",
  "admin.events.form.titleEn": "Title (English)",
  "admin.events.form.summaryCs": "Summary (Czech)",
  "admin.events.form.summaryEn": "Summary (English)",
  "admin.events.form.capacity": "Capacity",
  "admin.events.form.waitlistEnabled": "Enable waitlist",
  "admin.events.form.startsAt": "Starts at",
  "admin.events.form.endsAt": "Ends at",
  "admin.events.form.registrationOpensAt": "Registration opens",
  "admin.events.form.registrationClosesAt": "Registration closes",
  "admin.events.form.timezone": "Timezone",
  "admin.events.form.locationName": "Location name",
  "admin.events.form.locationAddress": "Address",
  "admin.events.enrollments.title": "Enrollments ({count})",
  "admin.events.enrollments.waitlisted": "Waitlisted: {count}",
  "admin.events.enrollments.empty": "No enrollments yet.",
  "admin.events.enrollments.columnUser": "User",
  "admin.events.enrollments.columnStatus": "Status",
  "admin.events.enrollments.columnSource": "Source",
  "admin.events.enrollments.columnRegisteredAt": "Registered at",
  "events.story.kicker": "Event command",
  "events.story.title": "Event control with the right signal density",
  "events.story.body": "Lifecycle, attendance policy, and enrollment activity stay readable without losing operational detail.",
  "events.story.metricEnrollment": "Active registrations",
  "events.story.metricWaitlist": "Waitlist pressure",
  "events.story.metricPolicy": "Current policy source",
  "events.story.rowLifecycle": "Lifecycle state",
  "events.story.rowLifecycleMeta": "The event can progress without losing context for operators or auditors.",
  "events.story.rowOperations": "Operational follow-through",
  "events.story.rowOperationsMeta": "Reporting, editing, and enrollment activity stay connected to the same event record.",
  "nav.tasks": "My tasks",
  "nav.reviewQueue": "Review queue",
  "attendee.tasks.title": "My tasks",
  "attendee.tasks.empty": "No tasks are assigned to this enrollment yet.",
  "attendee.tasks.emptyBody": "When an organizer adds a test, document, or form, it will appear here together with submission status.",
  "attendee.tasks.pickEnrollment": "Pick an enrollment to see its tasks.",
  "attendee.tasks.help.label": "Enrollment selection help",
  "attendee.tasks.help.body": "Tasks belong to a specific enrollment. If you are in multiple events, choose the right event first.",
  "attendee.tasks.kind.test": "Test",
  "attendee.tasks.kind.document": "Document",
  "attendee.tasks.kind.form": "Form",
  "attendee.tasks.required": "Required",
  "attendee.tasks.optional": "Optional",
  "attendee.tasks.openDetail": "Open task",
  "attendee.tasks.backToList": "Back to my tasks",
  "attendee.tasks.status.not_started": "Not started",
  "attendee.tasks.status.in_progress": "In progress",
  "attendee.tasks.status.submitted": "Submitted",
  "attendee.tasks.status.returned": "Returned for rework",
  "attendee.tasks.status.accepted": "Accepted",
  "attendee.tasks.status.rejected": "Rejected",
  "attendee.tasks.notes": "Note for the reviewer",
  "attendee.tasks.saveDraft": "Save draft",
  "attendee.tasks.submit": "Submit",
  "attendee.tasks.saved": "Changes saved.",
  "attendee.tasks.submitted": "Submission sent for review.",
  "attendee.tasks.testIntro": "Answer every required question. You can save a draft before submitting.",
  "attendee.tasks.formIntro": "Fields marked with an asterisk are required.",
  "attendee.tasks.documentIntro": "Upload the finished document. Files are scanned for malware before the reviewer sees them.",
  "attendee.tasks.uploads.title": "Uploads",
  "attendee.tasks.uploads.empty": "No files attached yet.",
  "attendee.tasks.uploads.addFile": "Attach file",
  "attendee.tasks.uploads.remove": "Remove",
  "attendee.tasks.uploads.pending": "Scanning…",
  "attendee.tasks.uploads.clean": "Clean",
  "attendee.tasks.uploads.infected": "Blocked (infected)",
  "attendee.tasks.uploads.error": "Scan error",
  "attendee.tasks.uploads.failed": "Scan failed",
  "attendee.tasks.uploads.unavailable": "Scanner unavailable",
  "attendee.tasks.uploads.bypassed": "Scan bypassed",
  "attendee.tasks.uploads.quarantined": "Quarantined",
  "attendee.tasks.uploads.failureClass.configuration": "Upload scan configuration is incomplete.",
  "attendee.tasks.uploads.failureClass.scanner_unavailable": "The scanner is currently unavailable.",
  "attendee.tasks.uploads.failureClass.transport": "The scanner could not process the file.",
  "attendee.tasks.uploads.failureClass.unexpected": "The scan result was inconclusive.",
  "attendee.tasks.uploads.retryability.retryable": "Retry possible after scanner recovery.",
  "attendee.tasks.uploads.retryability.not_retryable": "Retry is not expected to help.",
  "attendee.tasks.uploads.retryability.unknown": "Retryability is still unclear.",
  "attendee.tasks.decisionReason": "Reviewer note",
  "attendee.tasks.returnReason": "Rework note",
  "reviewer.queue.title": "Review queue",
  "reviewer.queue.empty": "No submissions waiting for review.",
  "reviewer.queue.eventFilter": "Event",
  "reviewer.queue.eventFilterAll": "All events",
  "reviewer.queue.status.submitted": "Submitted",
  "reviewer.queue.status.returned": "Returned",
  "reviewer.queue.openDetail": "Open review",
  "reviewer.submission.title": "Review submission",
  "reviewer.submission.backToQueue": "Back to queue",
  "reviewer.submission.participant": "Participant",
  "reviewer.submission.content": "Submission content",
  "reviewer.submission.uploads": "Attachments",
  "reviewer.submission.history": "Decision history",
  "reviewer.submission.decision.accept": "Accept",
  "reviewer.submission.decision.reject": "Reject",
  "reviewer.submission.decision.return": "Return for rework",
  "reviewer.submission.decision.comment": "Add comment",
  "reviewer.submission.comment": "Comment visible to the participant",
  "reviewer.submission.reason": "Decision reason (required to accept/reject/return)",
  "reviewer.submission.score": "Score",
  "reviewer.submission.scoreMax": "Max score",
  "reviewer.submission.recorded": "Decision recorded.",
  "reviewer.submission.action": "Decision",
  "reviewer.submission.reasonRequired": "Please provide a reason for this decision.",
  "reviewer.submission.noContent": "Participant has not submitted any content yet.",
  "reviewer.submission.scanEngine": "Scanner",
  "reviewer.submission.scanFailure": "Failure class",
  "reviewer.submission.scanRetryability": "Retryability",
  "tasks.kind.self_presentation_video": "Self-presentation video",
  "tasks.kind.candidate_contact_list": "Candidate contact list",
  "tasks.kind.meeting_report": "Meeting report",
  "tasks.readiness.storage.local_baseline": "Pilot storage",
  "tasks.readiness.storage.storage_configured": "Target storage configured",
  "tasks.readiness.storage.caveat.localBaseline": "Uploaded files are currently stored with the application. That is acceptable for pilot use, but production needs an approved target storage.",
  "tasks.readiness.scan.scan_mock": "Pilot file check",
  "tasks.readiness.scan.scan_configured": "File check configured",
  "tasks.readiness.scan.mode.mock": "Demo check",
  "tasks.readiness.scan.mode.clamav_tcp": "ClamAV TCP",
  "tasks.readiness.scan.caveat.mock": "This environment uses a demo file check. It keeps the flow testable, but production needs an approved antivirus check.",
  "tasks.readiness.kind.self_presentation_video": "Video uploads remain blocked until storage target, antivirus path, retention handling, and legal basis are formally decided.",
  "tasks.readiness.kind.candidate_contact_list": "Candidate contact-list uploads remain blocked until legal basis, retention, and controlled storage handling are formally approved.",
  "tasks.readiness.kind.meeting_report": "Meeting-report uploads remain blocked until the allowed format, retention, and legal/privacy basis are formally decided.",
  "admin.tasks.readiness.title": "Task attachment readiness",
  "admin.tasks.readiness.intro": "This section shows whether task attachments can be accepted safely and why some sensitive task types remain blocked.",
  "admin.tasks.readiness.storage": "Storage",
  "admin.tasks.readiness.scanning": "File check",
  "admin.tasks.readiness.storageSafety": "Production safety",
  "admin.tasks.readiness.productionSafe": "Production-capable",
  "admin.tasks.readiness.notProductionSafe": "Pilot only",
  "admin.tasks.readiness.blockedKinds": "Blocked task types",
  "admin.tasks.readiness.enabledKinds": "{count} enabled type(s)",
  "admin.tasks.readiness.blockers": "Blocking questions",
  "admin.tasks.readiness.requiredCapabilities": "Still required",
  "admin.tasks.readiness.capability.object_storage": "object storage",
  "admin.tasks.readiness.capability.antimalware": "antimalware",
  "admin.tasks.readiness.capability.legal_basis": "legal basis",
  "admin.tasks.readiness.capability.retention_policy": "retention policy",
  "notFound.title": "Page not found",
  "notFound.body": "The page you requested does not exist or has been moved.",
  "notFound.home": "Back to home",
  "scanner.title": "Organizer scanner",
  "scanner.intro": "Scan attendee QR codes or enter tokens manually. Scans captured offline are queued and replayed automatically.",
  "scanner.status.online": "Online",
  "scanner.status.offline": "Offline — queuing",
  "scanner.eventLabel": "Event",
  "scanner.selectEvent": "Select an event…",
  "scanner.modeLabel": "Input mode",
  "scanner.mode.token": "QR / token",
  "scanner.mode.enrollment": "Enrollment ID",
  "scanner.tokenLabel": "Token payload",
  "scanner.tokenPlaceholder": "Paste a scanned QR token…",
  "scanner.camera.open": "Scan QR",
  "scanner.camera.cancel": "Cancel scan",
  "scanner.camera.retry": "Try again",
  "scanner.camera.title": "Camera scan",
  "scanner.camera.body": "Point the rear camera at the attendee QR code. The token fills in automatically after a successful scan.",
  "scanner.camera.launchTitle": "Use the camera first",
  "scanner.camera.launchBody": "On phone, camera scanning is the fastest way to capture attendee QR tokens.",
  "scanner.camera.manualTitle": "Manual fallback",
  "scanner.camera.manualFallback": "If the camera is unavailable, close it and use manual entry.",
  "scanner.camera.viewportHint": "Center the attendee QR code inside the frame.",
  "scanner.camera.flash.success": "QR captured. Confirm check-in or check-out to finish the attendance action.",
  "scanner.camera.flash.cancelled": "Camera scanning closed. You can paste the token manually below.",
  "scanner.camera.status.starting": "Starting camera…",
  "scanner.camera.status.ready": "Camera ready",
  "scanner.camera.status.permission_denied": "Camera permission denied",
  "scanner.camera.status.unavailable": "Camera unavailable",
  "scanner.camera.status.unsupported": "Camera scanning is not supported here",
  "scanner.camera.status.invalid": "Detected QR is not usable",
  "scanner.enrollmentLabel": "Enrollment ID",
  "scanner.enrollmentPlaceholder": "e.g. 8c33…",
  "scanner.submit.checkIn": "Record check-in",
  "scanner.submit.checkOut": "Record check-out",
  "scanner.flash.recorded": "Check-in recorded.",
  "scanner.flash.checkOutRecorded": "Check-out recorded.",
  "scanner.flash.queued": "You are offline — scan queued for later.",
  "scanner.story.kicker": "On-site capture",
  "scanner.story.title": "Fast check-in, resilient when offline",
  "scanner.story.body": "Queue state, event context, and operator feedback remain visible under pressure.",
  "scanner.story.metricQueue": "Pending sync items",
  "scanner.story.metricMode": "Current input mode",
  "scanner.story.metricEvent": "Selected event",
  "scanner.story.rowCapture": "Capture and confirm",
  "scanner.story.rowCaptureMeta": "Immediate check-in feedback keeps the line moving.",
  "scanner.story.rowResilience": "Offline resilience",
  "scanner.story.rowResilienceMeta": "Queued scans replay with the same audit-friendly client reference.",
  "scanner.kind.token": "Token",
  "scanner.kind.enrollment": "Enrollment",
  "scanner.errors.noEvent": "Select an event before scanning.",
  "scanner.errors.noToken": "Paste or scan a token first.",
  "scanner.errors.noEnrollment": "Enter an enrollment ID first.",
  "scanner.errors.duplicate_scan": "Duplicate scan detected — ignoring.",
  "scanner.errors.enrollment_cancelled": "This enrollment has been cancelled.",
  "scanner.errors.enrollment_wrong_event": "Token does not belong to this event.",
  "scanner.errors.invalid_event_state": "This event is not accepting check-ins.",
  "scanner.errors.unknown_enrollment": "No enrollment found for that ID.",
  "scanner.errors.attendance_token_malformed": "Token is not a valid code.",
  "scanner.errors.attendance_token_bad_signature": "Token signature is invalid.",
  "scanner.errors.attendance_token_expired": "Token has expired.",
  "scanner.errors.attendance_token_revoked": "Token has been revoked.",
  "scanner.errors.attendance_token_unknown_jti": "Token is not recognized.",
  "scanner.errors.attendance_token_tenant_mismatch": "Token is from another tenant.",
  "scanner.errors.attendance_token_event_mismatch": "Token does not match this event.",
  "scanner.errors.attendance_token_enrollment_mismatch": "Token does not match any enrollment.",
  "scanner.queue.title": "Offline queue",
  "scanner.queue.empty": "No queued scans.",
  "scanner.queue.syncNow": "Sync now",
  "scanner.queue.syncing": "Syncing…",
  "scanner.queue.clearSynced": "Clear synced",
  "scanner.queue.columns.label": "Scan",
  "scanner.queue.columns.status": "Status",
  "scanner.queue.columns.attempts": "Attempts",
  "scanner.queue.columns.error": "Last error",
  "scanner.queue.columns.actions": "Actions",
  "scanner.queue.status.pending": "Pending",
  "scanner.queue.status.inflight": "Sending",
  "scanner.queue.status.synced": "Synced",
  "scanner.queue.status.failed": "Failed",
  "nav.notifications": "Notifications",
  "platform.title": "Platform administration",
  "platform.intro": "A separate workspace for organizations and core platform operational status.",
  "platform.story.kicker": "Platform overview",
  "platform.story.title": "Organization administration without mixed roles",
  "platform.story.body": "Platform administrators see organizations, languages, and operational status without entering event administration.",
  "platform.story.metricHealth": "Active organizations",
  "platform.story.metricLocales": "Supported languages",
  "platform.story.rowRegistry": "Organization overview",
  "platform.story.rowRegistryMeta": "Platform operators can quickly inspect the current set of onboarded organizations.",
  "platform.story.rowGovernance": "Operational administration",
  "platform.story.rowGovernanceMeta": "Status changes remain explicit and separated from event administration.",
  "platform.summary.total": "Organizations total",
  "platform.summary.active": "Active",
  "platform.summary.suspended": "Suspended",
  "platform.summary.archived": "Archived",
  "platform.tenants.title": "Organization overview",
  "platform.tenants.intro": "Core organization parameters relevant to platform operation.",
  "platform.create.title": "New organization",
  "platform.create.intro": "Creates the core organization record. Detailed onboarding may remain a separate operational step.",
  "platform.create.submit": "Create organization",
  "platform.create.localeMismatch": "The default language must also be present in the allowed languages list.",
  "platform.field.code": "Code",
  "platform.field.displayName": "Display name",
  "platform.field.status": "Status",
  "platform.field.defaultLocale": "Default locale",
  "platform.field.allowedLocales": "Allowed locales",
  "platform.field.createdAt": "Created",
  "platform.field.updatedAt": "Updated",
  "platform.status.active": "Active",
  "platform.status.suspended": "Suspended",
  "platform.status.archived": "Archived",
  "platform.cta.detail": "Details",
  "platform.back": "Back to organization overview",
  "platform.detail.intro": "Core organization metadata and operational status.",
  "platform.detail.storyTitle": "Organization administration stays explicit",
  "platform.detail.storyBody": "Identity, language setup, and operational state remain visible without mixing into event work.",
  "platform.detail.metricLocale": "Primary language",
  "platform.detail.metricLocales": "Allowed locale set",
  "platform.detail.metricStatus": "Registry state",
  "platform.detail.rowRegistry": "Organization record",
  "platform.detail.rowRegistryMeta": "Creation data and codes remain readable for platform operators.",
  "platform.detail.rowOperations": "Operational state",
  "platform.detail.rowOperationsMeta": "Status changes stay auditable and intentionally limited in scope.",
  "platform.detail.statusTitle": "Operational status",
  "platform.detail.statusBody": "Changing status here updates only the core organization record. Detailed onboarding and offboarding may remain a separate operational step.",
  "platform.action.active": "Activate",
  "platform.action.suspended": "Suspend",
  "platform.action.archived": "Archive",
  "admin.notifications.title": "Notifications",
  "admin.notifications.intro": "Template catalog, queued notification jobs and per-attempt delivery log. Read-only baseline — template authoring and targeted search land in a later slice.",
  "admin.notifications.tabs.templates": "Templates",
  "admin.notifications.tabs.jobs": "Jobs",
  "admin.notifications.tabs.deliveries": "Deliveries",
  "admin.notifications.templates.empty": "No notification templates are defined yet.",
  "admin.notifications.templates.code": "Code",
  "admin.notifications.templates.channel": "Channel",
  "admin.notifications.templates.locale": "Locale",
  "admin.notifications.templates.enabled": "Enabled",
  "admin.notifications.templates.enabledYes": "Yes",
  "admin.notifications.templates.enabledNo": "No",
  "admin.notifications.templates.subject": "Subject",
  "admin.notifications.templates.requiredVariables": "Required variables",
  "admin.notifications.jobs.empty": "No notification jobs yet.",
  "admin.notifications.jobs.created": "Created",
  "admin.notifications.jobs.trigger": "Trigger",
  "admin.notifications.jobs.template": "Template",
  "admin.notifications.jobs.recipient": "Recipient",
  "admin.notifications.jobs.status": "Status",
  "admin.notifications.jobs.attempts": "Attempts",
  "admin.notifications.jobs.error": "Last error",
  "admin.notifications.jobs.state.pending": "Pending",
  "admin.notifications.jobs.state.queued": "Queued",
  "admin.notifications.jobs.state.sent": "Sent",
  "admin.notifications.jobs.state.failed": "Failed",
  "admin.notifications.jobs.state.cancelled": "Cancelled",
  "admin.notifications.deliveries.empty": "No delivery attempts recorded yet.",
  "admin.notifications.deliveries.startedAt": "Started at",
  "admin.notifications.deliveries.channel": "Channel",
  "admin.notifications.deliveries.transport": "Transport",
  "admin.notifications.deliveries.status": "Status",
  "admin.notifications.deliveries.attempt": "Attempt",
  "admin.notifications.deliveries.error": "Error",
  "admin.notifications.deliveries.state.pending": "Pending",
  "admin.notifications.deliveries.state.sent": "Sent",
  "admin.notifications.deliveries.state.failed": "Failed",
  "admin.identity.title": "Identity and role mappings",
  "admin.identity.intro": "Operate the external directory baseline: map incoming directory groups to application roles and inspect each user's effective access.",
  "admin.identity.authMode": "Bearer auth mode",
  "admin.identity.posture": "Auth posture",
  "admin.identity.authMode.mock_oidc": "Mock OIDC",
  "admin.identity.authMode.external_oidc": "External OIDC",
  "admin.identity.readiness.title": "Posture readiness",
  "admin.identity.readiness.intro": "Shows the current runtime posture and the identity seams that are ready to wire without assuming the final Entra business decisions are already closed.",
  "admin.identity.readiness.browserLogin": "Browser login",
  "admin.identity.readiness.devBypass": "Dev bypass",
  "admin.identity.readiness.groupMappings": "Group mappings",
  "admin.identity.readiness.groupMappingsCount": "{count} configured",
  "admin.identity.readiness.state.ready": "Ready",
  "admin.identity.readiness.state.missing": "Missing",
  "admin.identity.readiness.state.enabled": "Enabled",
  "admin.identity.readiness.state.disabled": "Disabled",
  "admin.identity.readiness.claimMappings": "Claim mapping: {claims}",
  "admin.identity.readiness.requiredClaims": "Required claims: {claims}",
  "admin.identity.readiness.none": "none",
  "admin.identity.readiness.productionSafe": "This environment satisfies the production-safe auth posture contract, but real Entra validation and final business mappings still remain outside the repo.",
  "admin.identity.readiness.notProductionSafe": "This environment is intentionally still local, pilot, or incomplete. That is acceptable for rehearsal, but it is not evidence that go-live identity gates are closed.",
  "admin.identity.mappings.title": "Directory group mappings",
  "admin.identity.mappings.intro": "Mappings stay tenant-scoped and explicit. Customer-specific AD / Entra group names belong here, not in the business modules.",
  "admin.identity.mappings.empty": "No directory-group mappings are defined yet.",
  "admin.identity.mappings.directoryGroup": "Directory group",
  "admin.identity.mappings.role": "Role",
  "admin.identity.mappings.enabled": "Enabled",
  "admin.identity.mappings.enabledYes": "Yes",
  "admin.identity.mappings.enabledNo": "No",
  "admin.identity.mappings.updatedAt": "Updated",
  "admin.identity.mappings.actions": "Actions",
  "admin.identity.form.directoryGroupCode": "Directory group code",
  "admin.identity.form.directoryGroupPlaceholder": "entra:event-admins",
  "admin.identity.form.role": "Application role",
  "admin.identity.form.enabled": "Mapping is enabled",
  "admin.identity.flash.created": "Directory-group mapping created.",
  "admin.identity.flash.updated": "Directory-group mapping updated.",
  "admin.identity.access.title": "Effective access",
  "admin.identity.access.intro": "Shows the last seen directory-group snapshot per user together with the effective application roles derived from mappings and manual assignments.",
  "admin.identity.access.empty": "No identities are available yet.",
  "admin.identity.access.user": "User",
  "admin.identity.access.subject": "External subject",
  "admin.identity.access.groups": "Directory groups",
  "admin.identity.access.effectiveRoles": "Effective roles",
  "admin.identity.access.attributes": "Directory attributes",
  "admin.identity.access.status.active": "Active",
  "admin.identity.access.status.disabled": "Disabled",
  "admin.identity.access.status.pending": "Pending",
  "admin.identity.access.source.manual_assignment": "Manual assignment ({value})",
  "admin.identity.access.source.directory_group": "Directory group {value}",
  "admin.identity.access.source.platform_directory_group": "Platform directory group {value}",
  "admin.identity.access.source.mock_role_claim": "Mock role claim {value}",
  "admin.identity.access.source.dev_bypass": "Dev bypass ({value})",
  "admin.identity.access.scope.platform": "Platform",
  "admin.identity.access.scope.tenant": "Tenant",
  "admin.identity.readiness.platformAdminGroups": "Platform admin groups",
  "admin.identity.readiness.platformAdminGroups.configured": "Configured",
  "admin.identity.readiness.platformAdminGroups.missing": "Not set",
  "admin.identity.mappings.platformConflict.title": "Platform-reserved group conflicts",
  "admin.identity.mappings.platformConflict": "Directory group \"{group}\" is reserved for platform-plane admin resolution. This tenant-local mapping should be removed.",
  "session.workspace.platform": "Platform operations",
  "session.workspace.admin": "Tenant admin",
  "session.workspace.attendee": "My enrollment",
  "me.accessDiagnostics.title": "My effective access",
  "me.accessDiagnostics.scopePlatform": "Platform roles",
  "me.accessDiagnostics.scopeTenant": "Tenant roles",
  "me.accessDiagnostics.scopeNone": "No roles resolved",
  "admin.identity.attributes.manager": "Manager",
  "admin.identity.attributes.position": "Position",
  "admin.identity.attributes.level": "Level",
  "admin.identity.attributes.employmentStatus": "Employment status",
  "admin.identity.attributes.licenses": "Licenses",
  "nav.reporting": "Reporting",
  "reporting.title": "Event reporting",
  "reporting.intro": "Per-participant overview built from current enrollment, attendance, and task data. The report shows available signals without pre-judging a final HR decision.",
  "reporting.index.title": "Reporting",
  "reporting.index.intro": "Choose an event to inspect participant overview and exports.",
  "reporting.index.empty": "No events are available for reporting yet.",
  "reporting.index.emptyBody": "Reporting appears after an event is created and published. Once enrollments, attendance, or tasks start filling in, they will be available here for review.",
  "reporting.index.columnCode": "Code",
  "reporting.index.columnTitle": "Title",
  "reporting.index.columnState": "State",
  "reporting.index.columnStartsAt": "Starts",
  "reporting.index.open": "Open report",
  "reporting.openEvent": "Open report",
  "reporting.empty": "There are no participants for this event yet.",
  "reporting.generatedAt": "Generated at",
  "reporting.summary.title": "Summary",
  "reporting.summary.enrollment": "Enrollments",
  "reporting.summary.attendance": "Attendance",
  "reporting.summary.tasks": "Tasks",
  "reporting.summary.completion": "Completion",
  "reporting.summary.total": "Total: {count}",
  "reporting.warnings.title": "Important notes",
  "reporting.eventMeta.title": "Report metadata",
  "reporting.matrix.title": "Participant matrix",
  "reporting.conditions.title": "Declared event conditions",
  "reporting.condition.kind.entry": "Entry condition",
  "reporting.condition.kind.exit": "Exit condition",
  "reporting.condition.evaluation.deferred": "Condition evaluation is deferred in the baseline",
  "reporting.column.participant": "Participant",
  "reporting.column.role": "Event role",
  "reporting.column.enrollment": "Enrollment",
  "reporting.column.attendance": "Attendance",
  "reporting.column.tasks": "Tasks",
  "reporting.column.completion": "Completion",
  "reporting.role.custom": "Custom role",
  "reporting.warning.attendancePolicyConfigurable": "Attendance is evaluated with the current configurable baseline policy. Final business and HR meaning can still be refined per tenant or event type.",
  "reporting.warning.attendancePolicyDefaultFallback": "This event is using the system default attendance policy because no event-type or event-specific rule is configured yet.",
  "reporting.warning.attendancePolicyLegacyFallback": "This event is still using migrated legacy attendance thresholds. Move it to an explicit attendance policy rule for clearer U-06 governance.",
  "reporting.warning.completionBlocked": "Completion is still blocked where deferred tasks or policy questions remain. The report keeps those blockers explicit instead of over-claiming a final verdict.",
  "reporting.warning.completionPolicyBaseline": "Completion shows the current baseline contribution from attendance and tasks. It is more explicit than before, but still not a final legal or HR verdict.",
  "reporting.enrollment.registered": "Registered",
  "reporting.enrollment.waitlisted": "Waitlisted",
  "reporting.enrollment.cancelled": "Cancelled",
  "reporting.attendance.policyMet": "Meets attendance baseline",
  "reporting.attendance.withinPolicyExceptions": "Within allowed attendance exceptions",
  "reporting.attendance.policyNotMet": "Does not meet attendance baseline",
  "reporting.attendance.notApplicableWaitlisted": "Attendance not evaluated yet (waitlist)",
  "reporting.attendance.notApplicableCancelled": "Attendance not evaluated (cancelled enrollment)",
  "reporting.tasks.blockedAssignments": "Contains blocked tasks",
  "reporting.tasks.noActiveTasks": "No active tasks",
  "reporting.tasks.attentionRequired": "Needs reviewer or participant action",
  "reporting.tasks.allRequiredAccepted": "All required tasks accepted",
  "reporting.tasks.reviewPending": "Waiting for review / completion",
  "reporting.tasks.inProgress": "In progress",
  "reporting.tasks.notStarted": "Not started",
  "reporting.tasks.note.blockedAssignments": "This event contains tasks that are modelled in the baseline but still blocked because the privacy/policy questions are not closed yet.",
  "reporting.tasks.requiredAcceptedSummary": "Required accepted: {accepted}/{total}",
  "reporting.completion.notApplicableWaitlisted": "Completion not evaluated yet (waitlist)",
  "reporting.completion.notApplicableCancelled": "Completion not evaluated (cancelled enrollment)",
  "reporting.completion.blockedByDeferredTasks": "Completion blocked by deferred tasks/policy",
  "reporting.completion.baselineRequirementsMet": "Baseline requirements met",
  "reporting.completion.attendancePolicyNotMet": "Attendance baseline not met",
  "reporting.completion.requirementsOutstanding": "Some signals are still outstanding or unresolved",
  "reporting.note.late_arrival": "Late arrival",
  "reporting.note.early_departure": "Early departure",
  "reporting.note.partial_presence": "Partial presence",
  "reporting.note.allowed_absence_used": "Allowed absence used",
  "reporting.note.attendance_policy_not_met": "Attendance baseline not met",
  "reporting.note.attendance_policy_schedule_fallback": "Policy fell back to whole-event evaluation because schedule items are missing.",
  "reporting.note.attendance_policy_default_unit_fallback": "Policy fell back to whole-event evaluation because no day or session units were available.",
  "reporting.export.csv": "Export CSV",
  "reporting.export.pdf": "Export PDF",
  "reporting.export.downloading": "Generating…",
  "reporting.export.failed": "Export failed",
  "reporting.attendancePolicy.title": "Attendance policy",
  "reporting.attendancePolicy.intro": "This report shows the effective attendance policy baseline used for evaluation and export semantics.",
  "reporting.attendancePolicy.source": "Policy source",
  "reporting.attendancePolicy.sourceValue.event_instance": "Event-specific override",
  "reporting.attendancePolicy.sourceValue.event_type": "Event type baseline",
  "reporting.attendancePolicy.sourceValue.legacy_rules": "Legacy thresholds fallback",
  "reporting.attendancePolicy.sourceValue.default": "System default",
  "reporting.attendancePolicy.unitMode": "Evaluation unit",
  "reporting.attendancePolicy.unitModeValue.whole_event": "Whole event",
  "reporting.attendancePolicy.unitModeValue.event_day": "Per event day",
  "reporting.attendancePolicy.unitModeValue.schedule_item": "Per schedule item",
  "reporting.attendancePolicy.allowedAbsenceUnits": "Allowed absences",
  "reporting.attendancePolicy.minimumPresenceMinutes": "Minimum presence (minutes)",
  "reporting.attendancePolicy.lateGraceMinutes": "Late grace (minutes)",
  "reporting.attendancePolicy.earlyDepartureGraceMinutes": "Early leave grace (minutes)",
  "reporting.edocation.title": "eDOcation handoff",
  "reporting.edocation.intro": "Generate and inspect the current contract-ready attendance handoff artifact owned by the Integration module.",
  "reporting.edocation.contractPending": "The real eDOcation transport and acknowledgment contract is still pending U-10. This baseline stores and sends a mock contract-ready payload only.",
  "reporting.edocation.runtimeNote.mock_contract": "The real eDOcation contract is still open in U-10. This environment stays on the honest mock, stored-only path.",
  "reporting.edocation.runtimeNote.contract_ready": "The HTTP contract seam is prepared, but this environment still stores handoffs without live transmission until the final U-10 contract is closed.",
  "reporting.edocation.runtimeNote.transport_configured": "Live transport is enabled through the configurable HTTP seam, but the external contract is still treated as provisional until U-10 is formally closed.",
  "reporting.edocation.trigger": "Generate handoff",
  "reporting.edocation.triggering": "Generating handoff…",
  "reporting.edocation.empty": "No eDOcation handoffs have been triggered for this event yet.",
  "reporting.edocation.requestedAt": "Requested",
  "reporting.edocation.requestedBy": "By: {user}",
  "reporting.edocation.status": "Status",
  "reporting.edocation.participants": "Participants",
  "reporting.edocation.participantCount": "{count} participant(s)",
  "reporting.edocation.latestAttempt": "Latest attempt",
  "reporting.edocation.summary": "Summary",
  "reporting.edocation.summaryPending": "Payload summary not available yet.",
  "reporting.edocation.flash.sent": "Handoff processed.",
  "reporting.edocation.flash.stored": "Handoff stored in the current posture.",
  "reporting.edocation.flash.transmitted": "Handoff transmitted to the configured transport.",
  "reporting.edocation.flash.blocked": "Handoff generation was blocked by missing required event or participant data.",
  "reporting.edocation.flash.failed": "Handoff failed after payload generation.",
  "reporting.edocation.statusValue.pending": "Pending",
  "reporting.edocation.statusValue.generated": "Generated",
  "reporting.edocation.statusValue.sent": "Sent",
  "reporting.edocation.statusValue.awaiting_acknowledgment": "Awaiting acknowledgment",
  "reporting.edocation.statusValue.acknowledged": "Acknowledged",
  "reporting.edocation.statusValue.rejected": "Rejected",
  "reporting.edocation.statusValue.failed": "Failed",
  "reporting.edocation.statusValue.blocked": "Blocked",
  "reporting.edocation.attemptStatus.sent": "Sent",
  "reporting.edocation.attemptStatus.awaiting_acknowledgment": "Awaiting acknowledgment",
  "reporting.edocation.attemptStatus.acknowledged": "Acknowledged",
  "reporting.edocation.attemptStatus.rejected": "Rejected",
  "reporting.edocation.attemptStatus.failed": "Failed",
  "reporting.edocation.attemptStatus.blocked": "Blocked",
  "reporting.edocation.latestAttempt.none": "No delivery attempt recorded yet.",
  "reporting.edocation.adapter.mock_contract": "Mock contract-ready adapter",
  "reporting.edocation.adapter.http_contract": "Configurable HTTP contract adapter",
  "reporting.edocation.contractStatus.pending_u10": "Contract pending final U-10 interface details",
  "reporting.edocation.contractStatus.decision_ready": "Decision-ready contract posture",
  "reporting.edocation.contractStatus.validated_u10": "U-10 validated contract posture",
  "reporting.edocation.posture.mock_contract": "Mock contract",
  "reporting.edocation.posture.contract_ready": "Contract-ready",
  "reporting.edocation.posture.transport_configured": "Transport configured",
  "reporting.edocation.deliveryMode.stored_only": "Stored only",
  "reporting.edocation.deliveryMode.transmitted": "Transmitted",
  "reporting.edocation.transport.mock_payload_store": "Mock payload store",
  "reporting.edocation.transport.http_json": "HTTP JSON transport",
  "reporting.edocation.auth.none": "No auth configured",
  "reporting.edocation.auth.bearer_token": "Bearer token",
  "reporting.edocation.auth.static_header": "Static header",
  "reporting.edocation.ack.unsupported": "Acknowledgment unsupported",
  "reporting.edocation.ack.none": "No acknowledgment expected",
  "reporting.edocation.ack.synchronous": "Synchronous acknowledgment",
  "reporting.edocation.ack.asynchronous": "Asynchronous acknowledgment",
  "reporting.edocation.diagnostics.posture": "Current posture",
  "reporting.edocation.diagnostics.delivery": "Current delivery",
  "reporting.edocation.diagnostics.readiness": "Readiness",
  "reporting.edocation.diagnostics.endpoint": "Endpoint",
  "reporting.edocation.diagnostics.auth": "Auth",
  "reporting.edocation.diagnostics.ack": "Ack",
  "reporting.edocation.diagnostics.transmission": "Transmission",
  "reporting.edocation.diagnostics.targetTransport": "Target transport",
  "reporting.edocation.transmission.active": "Active",
  "reporting.edocation.transmission.inactive": "Stored-only",
  "reporting.edocation.caveat.u10Open": "U-10 remains open: final transport, auth, acknowledgment, and reconciliation semantics still need sign-off.",
  "reporting.edocation.caveat.mockOnly": "This environment is still on the mock contract path; no real upstream delivery is active.",
  "reporting.edocation.caveat.storeOnly": "The HTTP contract seam is prepared, but this environment is still storing handoffs without transmitting them.",
  "reporting.edocation.caveat.provisionalTransport": "Live transmission is enabled through a configurable seam, but the final external contract is still treated as provisional until U-10 closes.",
  "reporting.edocation.failureClass.configuration": "Blocked by integration configuration",
  "reporting.edocation.failureClass.contract_validation": "Blocked by payload contract validation",
  "reporting.edocation.failureClass.transport": "Transport failure",
  "reporting.edocation.failureClass.remote_rejection": "Remote rejection",
  "reporting.edocation.failureClass.unknown": "Unknown integration failure",
  "reporting.story.kicker": "Decision clarity",
  "reporting.story.title": "Completion signals made legible",
  "reporting.story.body": "Reporting and eDOcation handoff remain explicit, traceable, and presentation-ready.",
  "reporting.story.metricAttendance": "Event coverage baseline",
  "reporting.story.metricCompletion": "Completion signal set",
  "reporting.story.metricHandoff": "Recorded handoffs",
  "reporting.story.rowEvaluation": "Evaluation view",
  "reporting.story.rowEvaluationMeta": "Attendance, tasks, and completion remain visible side by side.",
  "reporting.story.rowExport": "Export readiness",
  "reporting.story.rowExportMeta": "CSV, PDF, and handoff artifacts are kept close to the live signal set.",
  "reporting.pdf.eventCode": "Event code",
  "reporting.pdf.eventType": "Event type",
  "reporting.pdf.startsAt": "Starts at",
  "reporting.pdf.endsAt": "Ends at",
  "reporting.pdf.generatedAt": "Generated at",
  "reporting.pdf.requestedBy": "Requested by",
  "reporting.pdf.summaryTitle": "Completion signal summary",
  "reporting.pdf.conditionsTitle": "Declared conditions",
  "reporting.pdf.participantsTitle": "Participants",
  "reporting.pdf.notes": "Notes",
  "attendance.policy.title": "Attendance policy",
  "attendance.policy.intro": "This event inherits the event-type attendance baseline unless you add an event-specific override. The rule stays configurable because U-06 is still a business-owned policy question.",
  "attendance.policy.source": "Policy source",
  "attendance.policy.sourceValue.event_instance": "Event-specific override",
  "attendance.policy.sourceValue.event_type": "Event type baseline",
  "attendance.policy.sourceValue.legacy_rules": "Legacy thresholds fallback",
  "attendance.policy.sourceValue.default": "System default",
  "attendance.policy.unitMode": "Evaluation unit",
  "attendance.policy.unitModeValue.whole_event": "Whole event",
  "attendance.policy.unitModeValue.event_day": "Per event day",
  "attendance.policy.unitModeValue.schedule_item": "Per schedule item",
  "attendance.policy.allowedAbsenceUnits": "Allowed absences",
  "attendance.policy.minimumPresenceMinutes": "Minimum presence (minutes)",
  "attendance.policy.lateGraceMinutes": "Late grace (minutes)",
  "attendance.policy.earlyDepartureGraceMinutes": "Early leave grace (minutes)",
  "attendance.policy.partialCountsAsAbsence": "Count partial presence as absence",
  "attendance.policy.flash.saved": "Attendance policy saved.",
  "attendance.policy.flash.removed": "Event-specific attendance override removed.",
  "attendance.policy.saving": "Saving…",
  "attendance.policy.save": "Save attendance policy",
  "attendance.policy.resetToInherited": "Reset to inherited policy"
}
